export const germanQueryBuilderLocalization: any = {
  'de': {
    'querybuilder': {
      'AddGroup': 'Gruppe hinzufügen',
      'AddCondition': 'Bedingung hinzufügen',
      'DeleteGroup': 'Gruppe löschen',
      'DeleteRule': 'Regel löschen',
      'AddButton': 'Gruppe/Bedingung hinzufügen',
      'True': 'Ja',
      'False': 'Nein',
      'AND': 'UND',
      'OR': 'ODER',
      'NOT': 'NICHT',
      'StartsWith': 'Beginnt mit',
      'NotStartsWith': 'Beginnt nicht mit',
      'EndsWith': 'Endet mit',
      'NotEndsWith': 'Endet nicht mit',
      'Contains': 'Enthält',
      'NotContains': 'Enthält nicht',
      'Equal': 'Gleich',
      'NotEqual': 'Ungleich',
      'LessThan': 'Kleiner als',
      'LessThanOrEqual': 'Kleiner oder gleich',
      'GreaterThan': 'Größer als',
      'GreaterThanOrEqual': 'Größer oder gleich',
      'Between': 'Zwischen',
      'NotBetween': 'Nicht zwischen',
      'In': 'Enthalten in',
      'NotIn': 'Nicht enthalten in',
      'Remove': 'Entfernen',
      'SelectField': 'Feld auswählen',
      'SelectOperator': 'Operator auswählen',
      'EnterValue': 'Wert eingeben',
      'IsEmpty': 'Ist leer',
      'IsNotEmpty': 'Ist nicht leer',
      'IsNull': 'Ist null',
      'IsNotNull': 'Ist nicht null',
      'Matches': 'Entspricht',
      'OtherFields': '',
    },

    'datepicker': {
      'placeholder': 'Wählen Sie ein Datum aus',
      'today': 'Heute',
    },

    'numerictextbox': {
      incrementTitle: 'Wert erhöhen',
      decrementTitle: 'Wert verringern',
    },
  },
};
